"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 14 14",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M7 0a7 7 0 1 0 7 7 7 7 0 0 0-7-7",
        fill: "#df3d0c",
        mask: "url(#prefix__mask-2)"
      }), (0, _jsxRuntime.jsx)("rect", {
        fill: "#fff",
        transform: "rotate(45 7 7)",
        x: 3,
        y: 6,
        width: 8,
        height: 2,
        rx: 1
      }), (0, _jsxRuntime.jsx)("rect", {
        fill: "#fff",
        transform: "rotate(135 7 7)",
        x: 3,
        y: 6,
        width: 8,
        height: 2,
        rx: 1
      })]
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};